;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesLadder = Marionette.ItemView.extend({
		template: null,
		ui: {
			'league_select': '',
			'round_select':  '',
			'sort_th':       '',
			'show_more' : '.js-load-more'
		},
		events: {
			'change @ui.league_select': 'changeLeague',
			'change @ui.round_select':  'changeRound',
			'click @ui.sort_th':        'sortTable',
			'click @ui.show_team':      'showUserTeam',
			'click @ui.show_more': 'showMoreUsers'
		},
		initialize: function() {
			this.scrollToTop();

			this.model.set({
				leagues:   [],
				rounds:    [],
				league:    {},
				teams:     [],
				show_more: false,
				round_id: 0
			});

			this.initViewOptions()
				.fetchViewData();

			return this;
		},

		initViewOptions: function(){

			this.league_id        = this.getOption('league_id');
			this.league           = this.getOption('league');
			this.leagues          = this.getOption('leagues');
			this.teams            = this.getOption('teams');
			this.rounds           = this.getOption('rounds');
			this.user             = this.getOption('user');
			this.offset           = 0;
			this.limit            = 50;
			this.show_more_status = false;

			return this;

		},


		fetchViewData: function(){

			this.showPreloader();
			
			var complete = [
				this.league.show().fetch({ data: { id: this.league_id } }),
				this.leagues.show_my().fetch(),
				this.teams.show_ladder().fetch({ data: { league_id: this.league_id, offset: this.offset , limit: this.limit } }),
				this.rounds.fetch({ cache: true, expires: 60 })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));

			return this;
		},

		initTemplate: function() {

			if (this.initData().isCanAccess()) {

				this.trigger('leagues:view:menu', this.league);
				this.initTeamsData()
					.setModelData()
					.render()
					.hidePreloader();
			}

			return this;
		},
		initData: function() {
			this.league.setCommissioner(this.user.get('id'));
			this.leagues = this.leagues.byStatus('scheduled', true);
			this.round_id = this.rounds.getLastGameRound().set('selected', true).get('id');

			this.available_rounds = this.rounds.getNonScheduledOptionsFromId(this.league.get('start_round'));


			return this;
		},
		initTeamsData: function() {
			//this.teams.sortByField('round_rank', false)
			this.teams.setRoundStats(this.round_id, _.pluck(this.available_rounds, 'val'), this.league.get('fixture'));

			return this;
		},
		isCanAccess: function() {
			if (!this.league.get('id') || this.league.get('status') == 'scheduled') {
				this.trigger('leagues:http_status:404');

				return false;
			}

			return true;
		},
		setModelData: function() {
			
			this.show_more_status = Boolean(this.league.get('num_teams') > this.teams.length);

			this.model.set({
				round_id:    this.round_id,
				league:      this.league.toJSON(),
				leagues:     this.leagues.toJSON(),
				teams:       this.teams.toJSON(),
				rounds:      this.available_rounds,
				sort_key:    this.teams.sort_key,
				sort_order:  this.teams.sort_order,
				avatars_url: CONFIG.AVATARS_URL,
				show_more:   this.show_more_status
			});

			return this;
		},
		changeLeague: function() {
			
			var league_id = +this.ui.league_select.val();

			this.trigger('leagues_ladder:change_league', league_id);

			return this;
		},
		changeRound: function() {
			this.round_id = +this.ui.round_select.val();
			let data = { league_id: this.league_id, order: 'round_rank' };

			if (this.rounds.get(this.round_id).get('status') === 'complete') {
				data.round = this.round_id;
			}

			this.teams
				.show_ladder()
				.fetch({ data })
				.then(this.updateLadder.bind(this));

			return this;
		},

		updateLadder: function() {

			_.each(this.available_rounds, round => {
				round.selected = round.val == this.round_id
			});

			this.initTeamsData().setModelData().render();

			return this;
		},

		sortTable: function(e) {
			var field = $(e.currentTarget).data('sort-field');

			this.teams.sortByField(field);

			return this.setModelData().render();
		},

		//TODO:enable for full platform if needed
		// sortTable: function(e) {
		// 	this.showPreloader();
		//
		// 	var field = $(e.currentTarget).data('sort-field');
		// 	this.sort_direction = this.getSortDirection(field);
		// 	this.sort_order = field;
		//
		// 	var data = { id: this.league_id, round: this.round_id, type: 'overall', offset: 0, limit: 50, order: this.sort_order, order_direction: this.sort_direction };
		//
		// 	this.ladder
		// 		.pseudoSortLeagueLadder(this.sort_order)
		// 		.league_ladder()
		// 		.fetch({data: data})
		// 		.then(_.bind(this.checkResponseLength, this))
		// 		.then(_.bind(this.updateLadder, this));
		//
		// 	return this;
		// },

		showUserTeam: function() {

			return this;
		},
		
		showMoreUsers: function(){

			this.showPreloader();

			this.teams
				.fetchLadder(this.league_id, this.round_id,  this.teams.get('ladder').length)
				.then(_.bind(_.partial(this.prependToLadder , this.teams.get('ladder')), this));


			return this;
		},

		prependToLadder: function(ladder){

			this.teams.set('ladder', ladder.concat(this.teams.get('ladder')));

			this.setModelData()
				.render()
				.hidePreloader();

			return this;

		}
	});

}(window, APP, Backbone, Marionette, $, _));